export default __webpack_public_path__ + "static/media/q30c_v2.358f727b.png";